import _ from 'lodash';
import { parOfferPrefinStep } from '../../../services/pricing';
import { ConElemPrefinStepRequest } from '../../../services/proposal';
import moment from 'moment';
// import moment from 'moment';

export function offerPrefinstepToElementStep(
  parOfferPrefinStep: parOfferPrefinStep[],
  finamount: number
): ConElemPrefinStepRequest[] {
  // SERV = serviceduration ==> ctecalculationtype
  // SERV = servicecalculationmethod ==> ctecalculationbasis
  // FIN = calculationmethod ==>ctecalculationtype

  const calculateDate = (prefinStepList: any[], _lctesstartdate?: string) => {
    let lctesstartdate = _lctesstartdate ?? moment().format('YYYY-MM-DD');
    let lctesenddate = moment().format('YYYY-MM-DD');
    let newData = _.orderBy(prefinStepList ?? [], 'ctesorder').map(
      (step, index) => {
        if (index > 0) {
          lctesstartdate = moment(lctesenddate)
            .add(1, 'day')
            .format('YYYY-MM-DD');
          lctesenddate = moment(lctesstartdate)
            .add(step.ctesduration, 'days')
            .format('YYYY-MM-DD');
        } else {
          lctesenddate = moment(lctesstartdate)
            .add(step.ctesduration, 'days')
            .format('YYYY-MM-DD');
        }
        return {
          ...step,
          ctesstartdate: lctesstartdate,
          ctesenddate: lctesenddate,
        };
      }
    );

    return newData;
  };
  
  let newParOfferPrefinStep = calculateDate(parOfferPrefinStep);
  //return (
  const list = newParOfferPrefinStep.map((e: parOfferPrefinStep) => {
    return {
      cteid: 0,
      ctrid: 0,
      ctesid: _.random(1000000, 350000),
      ctesorder: e.ctesorder,
      ctesstartdate: e.ctesstartdate ?? '',
      ctesduration: e.ctesduration,
      ctesperiodicityunit: e.ctesperiodicityunit,
      ctesperiodicity: e.ctesperiodicity,
      enddate: e.ctesenddate ?? '',
      calmethod: e.calmethod,
      calcmethod: e.calmethod,
      rateformula: e.rateformula,
      ratebasis: e.ratebasis,
      ratespread: e.ratespread,
      nominalrate: e.nominalrate,
      ctesstartamount:
        ((e.ctesamortizedcoef + e.ctesoutstandingcoef) * finamount) / 100,
      ctesinterestamount: 0,
      ctesamortizedcoef: e.ctesamortizedcoef,
      ctesamortizedamount: (e.ctesamortizedcoef * finamount) / 100,
      ctesrentalamount: 0,
      ctesoutstandingcoef: e.ctesoutstandingcoef,
      ctesoutstandingamount: (e.ctesoutstandingcoef * finamount) / 100,
    };
  });

  return list;
  //);
}
